import { h, Fragment } from "preact";
import LoginSignupTemplate from "../../LoginSignupTemplate";
import LoginParams from "../../types/LoginParams";
import { urlResolve } from "../../../../../foundation/utils/url";
import LoginSSOForm from "../../forms/LoginSSOForm";
import ResponsiveImage from "../../../../../library/ResponsiveImage";

import "./style.css";

interface Props {
    loginParams: LoginParams;
}

export function LoginSSOPage({ loginParams }: Props) {
    return (
        <>
            <LoginSignupTemplate
                illustration={<ResponsiveImage asset="img/onboarding-illustration-1.png"/>}
                displayIllustrationOnMobile={false}
                header="Great to have you here!"
                subHeader="You can login to access your workspace."
                form={<LoginSSOForm loginParams={loginParams}/>}
                footer={(
                    <div class="loginSSOPageFooter">
                        <a href={urlResolve("forgotPassword")}>Forgot password?</a>
                        <span>
                            No account yet? <a href={urlResolve("signup", { query: { source: loginParams.source } })}>Sign up.</a>
                        </span>
                    </div>
                )}/>
        </>
    );
}

export default LoginSSOPage;

